// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M11.9974 15.9974L14.6641 18.6641L20.6641 12.6641M12.2666 27.4652C12.7036 27.4074 13.145 27.526 13.4932 27.7941L15.0975 29.0252C15.6278 29.4326 16.3655 29.4326 16.8944 29.0252L18.5594 27.7467C18.8705 27.5082 19.263 27.403 19.6512 27.4549L21.734 27.7289C22.3961 27.8163 23.0346 27.4475 23.2909 26.8297L24.0923 24.892C24.2419 24.529 24.5293 24.2416 24.8922 24.092L26.8298 23.2905C27.4476 23.0357 27.8164 22.3957 27.729 21.7335L27.4653 19.7262C27.4076 19.2892 27.5261 18.8477 27.7942 18.4995L29.0252 16.8951C29.4326 16.3648 29.4326 15.627 29.0252 15.0982L27.7468 13.433C27.5083 13.1219 27.4031 12.7293 27.455 12.3412L27.729 10.2583C27.8164 9.59609 27.4476 8.95759 26.8298 8.7013L24.8922 7.89984C24.5293 7.75022 24.2419 7.46282 24.0923 7.09987L23.2909 5.16214C23.0361 4.54438 22.3961 4.1755 21.734 4.26291L19.6512 4.53697C19.263 4.59031 18.8705 4.48512 18.5609 4.24809L16.8958 2.96961C16.3655 2.56221 15.6278 2.56221 15.099 2.96961L13.4339 4.24809C13.1228 4.48512 12.7303 4.5903 12.3421 4.53994L10.2594 4.26587C9.59719 4.17846 8.95872 4.54734 8.70245 5.1651L7.90251 7.10283C7.75142 7.4643 7.46403 7.7517 7.10258 7.90281L5.16497 8.70278C4.54724 8.95907 4.17838 9.59757 4.26578 10.2598L4.53983 12.3427C4.5902 12.7308 4.48502 13.1234 4.248 13.433L2.96959 15.0982C2.56222 15.6285 2.56222 16.3663 2.96959 16.8951L4.248 18.5603C4.4865 18.8714 4.59168 19.264 4.53983 19.6521L4.26578 21.735C4.17838 22.3972 4.54724 23.0357 5.16497 23.292L7.10258 24.0935C7.46551 24.2431 7.7529 24.5305 7.90251 24.8934L8.70393 26.8312C8.95872 27.4489 9.59867 27.8178 10.2608 27.7304L12.2666 27.4652Z"
    />
  </svg>
);
const DoneMarkIcon = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default DoneMarkIcon;
